module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_07_stay-d6c0a17fea0fefb2a8a647f981050cb1.jpg";